import React from 'react';
import TableWithSummary from '../../../../components/table/TableWithSummary';
import { ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL } from '../../../../store/modules/account/user/models';
import { CS_QNA_LIST_SORT_OPTION_MODEL } from '../../../../store/modules/cs/qna/models';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { CS_INQUIRY_LIST_TABLE_EMPTY_TEXT } from '../../../../constants/service/app/csInquiryConstants';
import columns from '../../../account/user/detail/AccountUserDetailCsQnaInfo/columns';

const OrderQnaInfo = (props) => {
  const { qnaInfo, getList, getExcelDownload } = props;

  if (!qnaInfo.list.length) return null;

  const { list, filterOption, sortOption, pagination, summary } = qnaInfo;
  return (
    <div className="order-detail-content qna-info-content">
      <div className="title">상품 문의 리스트</div>

      <TableWithSummary
        className="order-detail-qna-list-table"
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL,
          sortOption: CS_QNA_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={CS_INQUIRY_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) => columns(utils)}
      />
    </div>
  );
};

export default OrderQnaInfo;
